import { useTranslation } from "react-i18next";

import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

export const ChildrenPredictionErrorState = () => {
  const { t } = useTranslation();

  return (
    <Stack justify={"center"} gap="0">
      <Text fz="xs" c="red">
        {t("qrl.prediction.error.title")}
      </Text>
      <Text fz="xs" c="dimmed">
        {t("qrl.prediction.error.subtitle")}
      </Text>
    </Stack>
  );
};
